import styled from 'styled-components'

export const Wrapper = styled.div``

export const FilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border-radius: 4px;
  margin: 32px 0 40px;
`

export const SearchWrapper = styled.form`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 4px;
  width: 100%;
  max-width: 50%;

  & > div {
    width: 100%;
  }

  button {
    max-width: 172px;
  }
`

export const Filters = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: flex-end;
`

export const ButtonAddDoctor = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  height: 48px;
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  span {
    font-weight: 600;
    font-size: 18px;
    color: white;
  }
`
